import { SWRUnwrapper } from '@tumelo/data-fetching'
import { Body1, Card, H2, Link, Stack } from '@tumelo/designsystem'
import { useRouter } from 'next/router'
import React from 'react'
import { useFetchListSchemes } from '../../application/hooks/useFetchListSchemes'
import { blankPrivilegesCtx, MappedPrivileges, PrivilegesContext, PrivilegesCtx } from '../../application/user'
import { getCurrentSlug } from '../../utils/getCurrentSlug'
import { PageLayout } from '../PageLayout'
import { Spinner } from '../Spinner'

interface LandingProps {
  children: React.ReactNode
}

export const Landing: React.FC<LandingProps> = ({ children }) => {
  const schemesResponse = useFetchListSchemes()

  const router = useRouter()
  const currentSlug = getCurrentSlug(router)

  return (
    <SWRUnwrapper
      response={schemesResponse}
      loadingComponent={
        <PrivilegesContext value={blankPrivilegesCtx}>
          <PageLayout>
            <Stack justifyContent="center">
              <Spinner />
              <Body1>Loading...</Body1>
            </Stack>
          </PageLayout>
        </PrivilegesContext>
      }
      errorComponent={
        <PrivilegesContext value={blankPrivilegesCtx}>
          <PageLayout>
            <Card>
              <H2 mb="3.2rem">Welcome to the Tumelo Stewardship platform</H2>
              <Body1>This platform is designed to help you steward the investments you own or represent. </Body1>
              <Body1>
                In order to access the appropriate data, please email us at{' '}
                <Link href="mailto:stewardship@tumelo.com">stewardship@tumelo.com</Link> with your name, company and the
                scheme or portfolio you require access to.
              </Body1>
            </Card>
          </PageLayout>
        </PrivilegesContext>
      }
    >
      {(data) => {
        const mappedPrivileges: MappedPrivileges = {
          canGetSchemes: data?.schemes || [],
        }
        const privilegesCtx: PrivilegesCtx = { mappedPrivileges }

        if (
          privilegesCtx &&
          (privilegesCtx.mappedPrivileges.canGetSchemes.length > 0 || router.asPath.includes(`${currentSlug}/profile`))
        ) {
          return <PrivilegesContext value={privilegesCtx}>{children}</PrivilegesContext>
        }

        return (
          <PrivilegesContext value={blankPrivilegesCtx}>
            <PageLayout>
              <Card>
                <H2 mb="3.2rem">Welcome to the Tumelo Stewardship platform</H2>
                <Body1>This platform is designed to help you steward the investments you own or represent. </Body1>
                <Body1>
                  In order to access the appropriate data, please email us at{' '}
                  <Link href="mailto:stewardship@tumelo.com">stewardship@tumelo.com</Link> with your name, company and
                  the scheme or portfolio you require access to.
                </Body1>
              </Card>
            </PageLayout>
          </PrivilegesContext>
        )
      }}
    </SWRUnwrapper>
  )
}
